import React from 'react'
import iconImage from '../../src/Assets/images/logo.png'
import iconImage1 from '../../src/Assets/images/logo-text.png'
import iconImage2 from '../../src/Assets/images/logo-text.png'

function MainHeader() {
    const toggleNav = (e) => {
        e.preventDefault();
        const mainWrapper = document.getElementById("main-wrapper");
        if (mainWrapper) {
            mainWrapper.classList.toggle("menu-toggle");
        }
        const hamburgers = document.querySelectorAll(".hamburger");
        hamburgers.forEach((el) => el.classList.toggle("is-active"));
    };

    return (
        <div className="nav-header">
            <a href="/" className="brand-logo">
                <img className="logo-abbr" src={iconImage} alt="Foodoor" />
                <img height="70" className="logo-compact" src={iconImage1} alt="Foodoor" />
                <img height="70" className="brand-title" src={iconImage2} alt="Foodoor" />
            </a>
            <div className="nav-control" onClick={toggleNav}>
                <div className="hamburger">
                    <span className="line" /><span className="line" /><span className="line" />
                </div>
            </div>
        </div>
    )
}

export default MainHeader
